import { gql } from "@apollo/client";
import registeredVehicleFragment, { RegisteredVehicle } from "common/graphql/fragments/registeredVehicleFragment";

/**
 * Query that retrieves paginated results of vehicles registered to the user's account.
 */
export const GET_CURRENTLY_REGISTERED_VEHICLES = gql`
  query GetCurrentlyRegisteredVehicles($limit: Int = 1000, $offset: Int = 0, $search: String = "%") {
    registeredVehicleCount: registered_vehicle_aggregate(
      where: {
        _or: [
          { license_plate: { _ilike: $search } }
          { make: { _ilike: $search } }
          { model: { _ilike: $search } }
          { state_code: { _ilike: $search } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    registeredVehicles: registered_vehicle(
      order_by: [{ updated_at: desc }]
      limit: $limit
      offset: $offset
      where: {
        _or: [
          { license_plate: { _ilike: $search } }
          { make: { _ilike: $search } }
          { model: { _ilike: $search } }
          { state_code: { _ilike: $search } }
        ]
      }
    ) {
      ...registeredVehicleFragment
    }
  }
  ${registeredVehicleFragment}
`;

/** Variables provided to the {@link GET_CURRENTLY_REGISTERED_VEHICLES} query */
export interface GetCurrentlyRegisteredVehiclesVars {
  /** Maximum number of results to return */
  limit?: number;
  /** Offset of results to retrieve */
  offset?: number;
  /** Search term (supports % wildcards, case-insensitive, matches plate/make/model/state) */
  search?: string;
}

/** Data returned by the {@link GET_CURRENTLY_REGISTERED_VEHICLES} query */
export interface GetCurrentlyRegisteredVehiclesData {
  /** Count of vehicles registered to the user's account */
  registeredVehicleCount: { aggregate: { count: number } };
  /** Registered vehicles */
  registeredVehicles: RegisteredVehicle[];
}

export default GET_CURRENTLY_REGISTERED_VEHICLES;
